import axiosInstance from "../../translator";
import { notificationSettings } from "../../constants/apis/apiEndpoints";

export const getNotificationTypes = () => {
  return axiosInstance
    .get(notificationSettings.notificationTypes)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      return err;
    });
};

export const getNotificationTypesList = (urlParams) => {
  return axiosInstance
    .get(`${notificationSettings.notificationTypes}${urlParams}`)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      return err;
    });
};

export const getReportNotificationTypeList = () => {
  return axiosInstance
    .get(`${notificationSettings.reportTypes}`)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      return err;
    });
};

export const setReportNotificationSettings = (data) => {
  return axiosInstance
    .post(`${notificationSettings.reportTypes}`, data)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      return err;
    });
};

export const updateNotificationSettingsApi = (data) => {
  return axiosInstance
    .post(notificationSettings.notificationTypes, data)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      return err;
    });
};

export const updateProfileApi = (data) => {
  return axiosInstance
    .post(notificationSettings?.updateProfile, data)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      return err;
    });
};
